/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { vatControllerGetAll } from '../fn/vat/vat-controller-get-all';
import { VatControllerGetAll$Params } from '../fn/vat/vat-controller-get-all';
import { VatListResponse } from '../models/vat-list-response';

@Injectable({ providedIn: 'root' })
export class VatService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vatControllerGetAll()` */
  static readonly VatControllerGetAllPath = '/vat';

  /**
   * Restituisce l'elenco delle VAT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vatControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vatControllerGetAll$Response(params?: VatControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: VatListResponse;
}>> {
    return vatControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle VAT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vatControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vatControllerGetAll(params?: VatControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: VatListResponse;
}> {
    return this.vatControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: VatListResponse;
}>): BaseResponse & {
'data'?: VatListResponse;
} => r.body)
    );
  }

}
